import React, {FC} from 'react';
import {ModerationUserTag} from "interfaces";
import {
    ModerationPhotoTag
} from "components/ModerationUserCard/ModerationPhotos/ModerationPhotoTags/ModerationPhotoTag";
import {SENSITIVE_TAGS, UserReviewTags} from "enums";


interface Props {
    reviewTags?: ModerationUserTag[]
    isSensitive: boolean
    hasNoFace: boolean
}


export const ModerationPhotoTags: FC<Props> = ({reviewTags, isSensitive, hasNoFace}) => {
    if (!reviewTags) {
        return <></>
    }

    let displayedTags = isSensitive
        ? reviewTags.filter(t => t.tag !== UserReviewTags.UpdatedPhotos)
        : reviewTags.filter(t =>
            ![...SENSITIVE_TAGS, UserReviewTags.ReviewRequiredPhoto, UserReviewTags.UpdatedPhotos].includes(t.tag))

    if (isSensitive && !reviewTags.filter(t => SENSITIVE_TAGS.includes(t.tag)).length) {
        displayedTags = [...displayedTags, {tag: UserReviewTags.SensitivePhoto}]
    }

    const distinct = Array.from(
        new Map(displayedTags.map(item => [item.tag, item])).values()
    );

    return <div className="d-flex flex-column align-items-start w-100 flex-wrap" style={{gap: 2}}>
        {distinct.map((t, i) =>
            <ModerationPhotoTag key={t + i.toString()} tag={t}/>
        )}
    </div>
};


